<template lang="pug">
  #TrialPlan
    .activity-page.text-center(v-if="isInited")
      .banner-area
        img(
          src='@/assets/images/trial-plan/reserve_banner.png?v=1'
        )
      .activity-area
        img(
          src='@/assets/images/trial-plan/index_rule_2024.png'
        )

        .button-area
          button(
            @click='toStart'
          )
            img(
              src='@/assets/images/trial-plan/button_start.png'
            )
          p *已成功綁定彩妝師將直接進入填寫收件資訊頁面
      .info-area
        img(
          src='@/assets/images/trial-plan/info_2024.png'
        )

</template>

<script>
import { mapState } from "vuex";
import { M_MY_SA_INDEX } from "@/router/member/my-sa";
import { M_PLAN_SIGN_UP_backMember } from "@/router/member/trial-plan";

export default {
  name: "TrialPlanIndex",
  data() {
    return {
      isInited: 1,
    };
  },
  created() {
    const vm = this;
    vm.$store.commit("toggleLoading", false);
    vm.isInited = 1;
  },
  methods: {
    toStart() {
      const vm = this;
      vm.$router.push({
        name: M_PLAN_SIGN_UP_backMember,
      });
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  height: auto;
  vertical-align: center;
  border-style: none;
}

button {
  border-radius: 0;
  text-transform: none;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
  &:hover {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
  }
  &:focus {
    outline: none;
    outline: none;
  }
}
select {
  &:focus {
    outline: none;
    outline: none;
  }
}
/*------ activity-page ------*/
.text-center {
  max-width: 540px;
  margin: 0 auto;
  min-height: 100%;
  text-align: center;
  padding: 0;
}
.activity-area {
  color: #fff;
  max-width: 100%;
  background: url(../../../assets/images/trial-plan/bg_form.png) top center repeat;
  background-size: 100%;
}
.button-area {
  padding-top: 8.5%;
  padding-bottom: 4.5%;
  button {
    width: 48%;
  }
  p {
    padding-top: 4%;
    margin-bottom: 0;
    font-size: 12px;
  }
}
@media (min-width: 768px) {
  p {
    font-size: 14px;
  }
}
</style>
